import { useBuildHubSlashContractQueueUrl } from '@/components/nav/utils/url-builders';
import FullscreenMessage from '@/components/ui/layout/fullscreen-message';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

export const Route = createFileRoute('/(authenticated)/$hub/contract-status/')({
  component: ContractStatusPage,
  staticData: {
    keepAlive: true,
  },
});

function ContractStatusPage() {
  const contractQueueUrl = useBuildHubSlashContractQueueUrl();

  const navigate = useNavigate();
  useEffect(() => {
    navigate({ to: contractQueueUrl });
  }, [contractQueueUrl]);

  return (
    <FullscreenMessage>
      <div className="text-2xl">This route is moved to /contract-queue</div>
      <p>You will be redirected to the new route in a few seconds.</p>
    </FullscreenMessage>
  );
}
